module.exports = __webpack_public_path__ + "static/img/homeGroup.8a5a696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/homeGroup.png
// module id = GA1t
// module chunks = 0